import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '!bg-system-gray-100 flex p-0!',
    closeButton: 'fixed md:top-[2%] md:right-[12.7%]'
  },
  variants: {
    color: {
      primary: 'text-main'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
